// ** MUI Imports
import { useTheme } from '@mui/material/styles'

// ** Util Import
import { hexToRGBA } from '../utils/hex-to-rgba'

const UseBgColor = () => {
  // ** Hooks
  const theme = useTheme()

  return {
    primaryFilled: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main
    },
    primaryLight: {
      color: theme.palette.primary.main,
      backgroundColor: hexToRGBA(theme.palette.primary.main, 0.16)
    },
    secondaryFilled: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main
    },
    secondaryLight: {
      color: theme.palette.secondary.main,
      backgroundColor: hexToRGBA(theme.palette.secondary.main, 0.16)
    },
    successFilled: {
      color: theme.palette.success.contrastText,
      backgroundColor: theme.palette.success.main
    },
    successLight: {
      color: theme.palette.success.main,
      backgroundColor: hexToRGBA(theme.palette.success.main, 0.16)
    },
    errorFilled: {
      color: theme.palette.error.contrastText,
      backgroundColor: theme.palette.error.main
    },
    errorLight: {
      color: theme.palette.error.main,
      backgroundColor: hexToRGBA(theme.palette.error.main, 0.16)
    },
    warningFilled: {
      color: theme.palette.warning.contrastText,
      backgroundColor: theme.palette.warning.main
    },
    warningLight: {
      color: theme.palette.warning.main,
      backgroundColor: hexToRGBA(theme.palette.warning.main, 0.16)
    },
    infoFilled: {
      color: theme.palette.info.contrastText,
      backgroundColor: theme.palette.info.main
    },
    infoLight: {
      color: theme.palette.info.main,
      backgroundColor: hexToRGBA(theme.palette.info.main, 0.16)
    },
    tealFilled: {
      color: theme.palette.teal.contrastText,
      backgroundColor: theme.palette.teal.main
    },
    tealLight: {
      color: theme.palette.teal.main,
      backgroundColor: hexToRGBA(theme.palette.teal.main, 0.16)
    },
    violetFilled: {
      color: theme.palette.violet.contrastText,
      backgroundColor: theme.palette.violet.main
    },
    violetLight: {
      color: theme.palette.violet.main,
      backgroundColor: hexToRGBA(theme.palette.violet.main, 0.16)
    },
    yellowFilled: {
      color: theme.palette.yellow.contrastText,
      backgroundColor: theme.palette.yellow.main
    },
    yellowLight: {
      color: theme.palette.yellow.main,
      backgroundColor: hexToRGBA(theme.palette.yellow.main, 0.16)
    },
  }
}

export default UseBgColor
